import { render, staticRenderFns } from "./NeedsStudentAdd.vue?vue&type=template&id=43fc8598&scoped=true"
import script from "./NeedsStudentAdd.vue?vue&type=script&lang=js"
export * from "./NeedsStudentAdd.vue?vue&type=script&lang=js"
import style0 from "./NeedsStudentAdd.vue?vue&type=style&index=0&id=43fc8598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fc8598",
  null
  
)

export default component.exports